import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { email } = action.payload;
    const url = config.api.paths.userWelcomeRequest;
    try {
        const { data } = yield call(http.authorized.post, url, email);
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On user welcome request post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.USER_WELCOME_REQUEST_POST_REQUEST, post)
    ]);
}
